export default "__VITE_ASSET__DzF1p2K0__"